import { fExecuteAPI } from "../../Server/Apis";
import {
  StockTransferReceipt_SaveDetail_GETROW,
  StockTransferReceipt_LoadDetail_GETROW,
  StockTransferReceipt_Attributes_GETROW,
  StockTransferReceipt_ApproveDetail_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import { Set_SliceStockTransferReceipt_HeadObject_A_DocStat } from "./SliceStockTransferReceipt";
import moment from "moment";
import { vRdxUserInfo, StockTransferReceiptRo } from "../../Redux/roStore";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_Itmcd: "",
  B_ItmName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_Packing: "", //Decimal
  B_BaseQty: "", //Decimal
};

export const sTrnTyp = "INV10R";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI("SEARCHEXACTITEM_GETROW", FinalObj);
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === defUnitValue;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: currentUnitArr[0].Unit,
          B_UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
          B_Packing: currentUnitArr[0].PackDesc,
        }));
      }
      // let vItemUnitSet = currentUnitArr.find((obj) => {
      //   return obj.Unit === vItemSearchFull[0].DefUnit;
      // });
      // if (!!vItemUnitSet) {
      //   setBufferObj((obj) => ({
      //     ...obj,
      //     B_Unit: vItemUnitSet.Unit,
      //     B_UnitName: vItemUnitSet.Name1,
      //     B_PackQty: vItemUnitSet.PackQty,
      //   }));
      // } else {
      //   let vItemUnitSet = currentUnitArr.find((obj) => {
      //     return obj.Unit === vItemSearchFull[0].PurUOM;
      //   });
      //   if (!!vItemUnitSet) {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: vItemUnitSet.Unit,
      //       B_UnitName: vItemUnitSet.Name1,
      //       B_PackQty: vItemUnitSet.PackQty,
      //     }));
      //   } else {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: currentUnitArr[0].Unit,
      //       B_UnitName: currentUnitArr[0].Name1,
      //       B_PackQty: currentUnitArr[0].PackQty,
      //     }));
      //   }
      // }
    }
    setTimeout(() => {
      const element = document.querySelector('[tabindex="103"]');
      element.focus();
    }, 500);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0].focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;
  if (
    vRdxHead.DocNo === "" ||
    vRdxHead.DocNo === null ||
    vRdxHead.DocNo === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      DocNo: "Document Number should not be empty",
    }));

    iRes = false;
  }
  if (
    vRdxHead.DocType === "" ||
    vRdxHead.DocType === null ||
    vRdxHead.DocType === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      DocType: "Document Type should not be empty",
    }));

    iRes = false;
  }

  if (
    vRdxHead.Loc === "" ||
    vRdxHead.Loc === null ||
    vRdxHead.Loc === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, Loc: "Location should not be empty" }));
    iRes = false;
  }
  if (
    vRdxHead.LocTo === "" ||
    vRdxHead.LocTo === null ||
    vRdxHead.LocTo === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, LocTo: "Location should not be empty" }));
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.Date === "" ||
    vRdxHead.Date === null ||
    vRdxHead.Date === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      Date: "Date should not be empty",
    }));
    iRes = false;
  }

  if (vRdxHead.A_DocStat !== "ENTER") {
    fAlertToast("FAILED", "Document status should be  Enter");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;
  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Qty === "" ||
    Number(sBufferObj.B_Qty) <= 0 ||
    (sBufferObj.B_Qty === null) | (sBufferObj.B_Qty === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
  }

  return iRes;
};
//API SaveSIHead
const fSaveHead = async (fNewDetail, sBufferObj) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObj } = StockTransferReceiptRo();
  let vSaveSIHeadObj = {
    v_B_VocTyp: HeadObj.DocType,
    v_B_VocNo: HeadObj.DocNo,
    v_B_Srno: sBufferObj.B_Srno,
    v_B_Itmcd: sBufferObj.B_Itmcd,
    v_B_Qty: sBufferObj.B_Qty,
    v_B_Unit: sBufferObj.B_Unit,
    v_UserCd: vRdxUserInfoObj.UserID,
    v_IP: vRdxUserInfoObj.IP,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await StockTransferReceipt_SaveDetail_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    //approve bool type false
    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  }
};
export const fApproveDetail = async (fNewDetail, dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObj } = StockTransferReceiptRo();
  let vSaveSIHeadObj = {
    v_R_VocTyp: HeadObj.DocType,
    v_R_VocNo: HeadObj.DocNo,
    v_UserCd: vRdxUserInfoObj.UserID,
    v_IP: vRdxUserInfoObj.IP,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
    From_Loc_CODE: HeadObj.Loc,
    To_Loc_CODE: HeadObj.LocTo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await StockTransferReceipt_ApproveDetail_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    // Set_SliceStockTransferReceipt_HeadObject_A_DocStat
    dispatch(
      Set_SliceStockTransferReceipt_HeadObject_A_DocStat({
        A_DocStat: "POST",
      })
    );
    fAlertToast("SUCCESS", "Successfully posted");
    fNewDetail();
  }
};

const GetSIDetail = async () => {
  const { HeadObj } = StockTransferReceiptRo();

  let iSIDetailObj = {
    v_R_VocTyp: HeadObj.DocType,
    v_R_VocNo: HeadObj.DocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await StockTransferReceipt_LoadDetail_GETROW(
    FinalObj
  );
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      return iSIDetailResult?.data.ResultSet;
    } else {
      return [];
    }
  }
};
const fLoad_Grid = async (setDetailGridData) => {
  const iSIDetail = await GetSIDetail();
  if (iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

export const GetAttributes = async (setStatus, setLocTo, setLocFrom) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vAttributeObj = {
    userCd: vRdxUserInfoObj.UserID,
  };
  const vDCRequestTransAttributes =
    await StockTransferReceipt_Attributes_GETROW(vAttributeObj);
  if (vDCRequestTransAttributes?.status === 200) {
    setStatus(vDCRequestTransAttributes?.data?.ResultSet?.Status);
    setLocTo(vDCRequestTransAttributes?.data?.ResultSet?.ToLoc);
    setLocFrom(vDCRequestTransAttributes?.data?.ResultSet?.FromLoc);
    return vDCRequestTransAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export {
  GetItemFullSearchArr,
  GetUnitArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
};
